import { render } from "./TopVendorsByExpensesWidget.vue?vue&type=template&id=74a62f4a"
import script from "./TopVendorsByExpensesWidget.vue?vue&type=script&lang=js"
export * from "./TopVendorsByExpensesWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__